import { Field, type FormikProps } from 'formik';
import * as React from 'react';
import { GLOBAL_CONSTANTS } from '../../constants/globals';
import { ACCEPT_TERMS } from '../../constants/signUp.constants';
import type { UserSignUp } from '../../interfaces/auth.interface';

interface AcceptTermsProps {
  formikProps: FormikProps<UserSignUp>;
}

export function AcceptTerms(props: AcceptTermsProps): React.JSX.Element {
  const { IS_INVALID } = GLOBAL_CONSTANTS;
  const { formikProps } = props;

  const render = (
    <div className="Signup__CheckBox">
      <Field
        className={`Signup__FormCheck form-check-input ${
          formikProps.errors.acceptTerms && formikProps.touched.acceptTerms
            ? IS_INVALID
            : null
        }`}
        disabled={
          Object.keys(formikProps.touched).length === 0 ||
          Object.keys(formikProps.errors).length !== 0
        }
        name="acceptTerms"
        type="checkbox"
      />
      <label className="form-check-label" htmlFor="acceptTerms">
        {ACCEPT_TERMS}
      </label>
      {formikProps.errors.acceptTerms && formikProps.touched.acceptTerms ? (
        <p className="custom-invalid-feedback">
          {formikProps.errors.acceptTerms}
        </p>
      ) : null}
    </div>
  );

  return render as React.JSX.Element;
}
